"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgParking(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448-201.6 448-448 448zm48-688H432c-19.2 0-32 12.8-32 32v384c0 19.2 12.8 32 32 32s32-12.8 32-32V528h96c70.4 0 128-57.6 128-128s-57.6-128-128-128zm0 192h-96V336h96c35.2 0 64 28.8 64 64s-28.8 64-64 64z"
  }));
}

var ForwardRef = React.forwardRef(SvgParking);
var _default = ForwardRef;
exports.default = _default;